import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 치료를 결심한 이유(메모) 조회
export function getDecisionReasonMemoFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/decision-reason/memo',
        method: 'get',
        params: {pid}
    })
}

// 치료를 결심한 이유(사진) 조회
export function getDecisionReasonImageFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/decision-reason/image',
        method: 'get',
        params: {pid},
        responseType: 'blob'
    })
}